

export const MOVEMENT_CONTROLS = {
    tilt_pan: "tilt_pan",
    truck_dolly: "truck_dolly",
}

export const TERRAIN_HEIGHT_MAP = {
    none: "none",
    height: "height",
    watersheds: "watersheds",
}
